import React, { useState } from 'react';
import classNames from 'classnames/bind';
import properties from '../../../../../../modules/ajio-util/properties';
import styles from './index.pcss';

const cx = classNames.bind(styles);
const imageBaseUrl = properties.getProperty('imageBaseUrl');
const getItemKey = item => item?.key || item?.title || item?.faqTopic || 'faq-item';
const getFaqKey = faq => faq?.id || faq?.question || 'faq-question';
const getAnswerKey = (faq, answer) => `${getFaqKey(faq)}-${answer}`;

const FaqAccordion = ({
  accordionItems = [],
  isDeliveredEntriesEmpty,
  isThankYouPage = false,
  handleDownloadInvoiceClick,
  handleAccordionClick,
  luxe
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleItem = index => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleAccordionToggle = index => {
    toggleItem(index);
    if (handleAccordionClick) {
      handleAccordionClick(accordionItems[index]?.title);
    }
  };

  const isDownloadDisabled = isDeliveredEntriesEmpty || isThankYouPage;

  return (
    <div className={cx('faq-container', { 'luxe-faq-container': luxe })}>
      {accordionItems.map((item, index) => (
        <div key={getItemKey(item)} className={cx('accordion-item')}>
          <div
            className={cx('accordion-header')}
            onClick={() => {
              handleAccordionToggle(index);
            }}
            role="button"
            tabIndex={0}
            onKeyDown={e => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleAccordionToggle(index);
              }
            }}
          >
            <span className={cx('accordion-title')}>{item?.title}</span>
            <span className={cx('accordion-toggle')}>
              {activeIndex === index ? (
                <img src={`${imageBaseUrl}/static/img/FaqClose.svg`} alt="Collapse FAQ" />
              ) : (
                <img src={`${imageBaseUrl}/static/img/FaqOpen.svg`} alt="Expand FAQ" />
              )}
            </span>
          </div>

          {activeIndex === index && item?.questionAnswer?.length > 0 && (
            <ol className={cx('faq-list')}>
              {item.questionAnswer.map(faq => (
                <li key={getFaqKey(faq)}>
                  {faq?.question}
                  <ol className={cx('alpha-list')}>
                    {faq?.answers?.map(answer => {
                      if (typeof answer === 'string' && answer.includes('{DownloadInvoice}')) {
                        return (
                          <li key={getAnswerKey(faq, answer)}>
                            <span
                              className={cx('download-link', {
                                'download-link-disabled': isDownloadDisabled
                              })}
                              onClick={!isDownloadDisabled ? handleDownloadInvoiceClick : undefined}
                            >
                              Download Invoice
                            </span>{' '}
                            {answer.replace('{DownloadInvoice}', '')}
                          </li>
                        );
                      }

                      if (typeof answer === 'string' && answer.includes('{here}')) {
                        return (
                          <li key={getAnswerKey(faq, answer)}>
                            {answer.replace('{here}', '')}{' '}
                            <span
                              className={cx('download-link', {
                                'download-link-disabled': isDownloadDisabled
                              })}
                              onClick={!isDownloadDisabled ? handleDownloadInvoiceClick : undefined}
                            >
                              here
                            </span>
                          </li>
                        );
                      }

                      return <li key={getAnswerKey(faq, String(answer))}>{answer}</li>;
                    })}
                  </ol>
                </li>
              ))}
            </ol>
          )}
        </div>
      ))}
    </div>
  );
};

export default FaqAccordion;
